// extracted by mini-css-extract-plugin
export var blink = "_90-2";
export var cursor = "_90-1";
export var reactMarkdown = "_90-3";
export var streamingText = "_90-0";